module.exports = __webpack_public_path__ + "static/media/ph_beaker_1.fe96c37d.svg";